import _pt from "prop-types";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
/**
 * Overlay of the modal. Dark background behind Modal dialog
 */
export var Overlay = function Overlay(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: "lmig-Modal-overlay",
    role: "none"
  }, onClick && {
    onClick: onClick
  }));
};
Overlay.propTypes = {
  /** event to fire when the user clicks the overlay */onClick: _pt.func
};